import { Modal, Spin } from 'antd';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { useFetch } from '../../../../../hooks/useFetch/useFetch';
import { useState } from 'react';
import { DrawerPanelTitle, modalPanelStyles } from '../../../common/Drawers/DrawerPanelTitle';
import { getReportPeriodLabel } from '../reportPeriodUtils';

export const PreviewReportModal = (props: {
  reportInfo: {
    type: string;
    schedule_type: string;
    locationId?: string;
    execute?: boolean;
    openTime?: string;
    closeTime?: string;
  };
  onFinish: any;
}) => {
  
  const { projectGroup } = useAuth();    
  const [reportContent, setReportContent] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  const locationIdOpt = props.reportInfo.locationId ? `/${props.reportInfo.locationId}` : '';

  const periodLabel =
    props.reportInfo.openTime && props.reportInfo.closeTime
      ? getReportPeriodLabel({
          openTime: props.reportInfo.openTime,
          closeTime: props.reportInfo.closeTime,
          scheduledType: props.reportInfo.schedule_type,
        })
      : null;

  useFetch(
    `${process.env.REACT_APP_API}/projects/${projectGroup.project}/server-reports${locationIdOpt}/type/${props.reportInfo.type}/preview?schedule_type=${props.reportInfo.schedule_type}`,
    {},
    [],
    (data) => {
      setReportContent(data);
      setIsLoading(false);
    }
  );
  return (
    <Modal 
        open={true}         
        onCancel={props.onFinish}         
        footer={null}
        width={'80%'}
        style={{
          top: 16,
          padding: 0,
          height: 'calc(100vh - 32px)',
          maxWidth: '98vw',
        }}
        className={modalPanelStyles.className}
        bodyStyle={{ 
          ...modalPanelStyles.bodyStyle,
          height: 'calc(95vh - 80px)', 
          overflow: 'auto',
          padding: 24,
          display: 'flex',
          flexDirection: 'column'
        }}
        centered
        title={
          <DrawerPanelTitle
            title={props.reportInfo.execute ? 'Ejecución del informe' : 'Previsualización del informe'}
            subtitle={
              periodLabel ? (
                <span>
                  {periodLabel.range}
                  {periodLabel.detail ? <> · {periodLabel.detail}</> : null}
                </span>
              ) : undefined
            }
            {...(!props.reportInfo.locationId ? { isProject: true } : {})}
          />
        }
    >
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          {isLoading ? (
            <div style={{ width: '100%', flex: 1, minHeight: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Spin size="large" />
            </div>
          ) : (
            <iframe        
              srcDoc={reportContent}
              title="Report Preview"
              style={{ width: '100%', height: '100%', minHeight: '70vh', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', flex: 1, border: 'none' }}
              //frameBorder="0"
            />
          )}
        </div>
    </Modal>
  );
};
